import { useContext } from 'react';
import { DocumentContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { LocaleService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { getBreakpoint, propagateProps } from '@philips-internal/oswald-ui-utils';
function usePropsManager(options) {
    const { engineComponent, ...otherProps } = options;
    const documentContext = useContext(DocumentContext);
    const breakpoint = getBreakpoint(documentContext.window);
    const locale = LocaleService.getCurrentLocale();
    const processedProps = engineComponent.getPropsProcessor()
        .collect(otherProps, breakpoint, locale);
    const listeners = engineComponent.getEventDelegator()
        .collect(otherProps);
    return {
        ssot: engineComponent.getSSOT(),
        ...processedProps,
        ...listeners,
    };
}
function PropsManager(props) {
    const { children, ...otherProps } = props;
    const properties = usePropsManager(otherProps);
    return propagateProps(children, properties);
}
export { usePropsManager, PropsManager, };
//# sourceMappingURL=props-manager.js.map